import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Global handler for trial-expired/payment-required errors.
// Components can still catch their own errors; this is a safety net + global redirect.
let paywallRedirectAt = 0;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail || "";
      // Distinguish trial-expired (route to /pricing) from plan-cap-reached (just surface).
      const isTrialExpired = /trial has ended|trial.*ended/i.test(detail);
      if (isTrialExpired) {
        const now = Date.now();
        if (now - paywallRedirectAt > 2000 && typeof window !== "undefined") {
          paywallRedirectAt = now;
          // Use a small delay so the throwing component can still show a toast.
          setTimeout(() => {
            if (!window.location.pathname.startsWith("/pricing")) {
              window.location.href = "/pricing";
            }
          }, 400);
        }
      }
    }
    return Promise.reject(err);
  }
);
